import { AUTH, PRESCREENING, ROUTE } from '@/constants';
import { loadView } from '../index';

const OperatorLogsDashboardView = loadView(
  'operator-logs/OperatorLogsDashboardView',
);

const operatorLogsRoute = {
  path: ROUTE.PATH.OPERATOR_LOGS,
  component: () => import('@/layouts/default/DefaultLayout.vue'),
  meta: {
    auth: AUTH.USER_ROLE.AUTHORIZED,
    tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
  },
  children: [
    {
      path: '',
      name: ROUTE.NAME.OPERATOR_LOGS,
      component: OperatorLogsDashboardView,
      meta: {
        auth: AUTH.USER_ROLE.AUTHORIZED,
        tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
      },
    },
    {
      path: ROUTE.PATH.OPERATOR_LOGS_DASHBOARD,
      name: ROUTE.NAME.OPERATOR_LOGS_DASHBOARD,
      component: OperatorLogsDashboardView,
      meta: {
        auth: AUTH.USER_ROLE.AUTHORIZED,
        tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
      },
    },
  ],
};

export default operatorLogsRoute;
